@import (reference) '../../../../../constants/spacing.module.less';

.details-panel {
  max-width: 300px;
  height: 100%;
  padding: @space-24;
  border-right: 1px solid var(--grey-300);
  background-color: var(--white);
}

.feedback-button {
  margin-top: auto;
}

.textarea {
  height: 150px;
  padding: @space-8;
  font-size: 14px;
}
